module.exports = __webpack_public_path__ + "img/AS.6db59a9a.svg";